import { render, staticRenderFns } from "./copy-chart.vue?vue&type=template&id=b918cf00&scoped=true&"
import script from "./copy-chart.vue?vue&type=script&lang=js&"
export * from "./copy-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b918cf00",
  null
  
)

export default component.exports